
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignFoundationsWritings',
  components: { DesignContentLayout }
};
